// Configuration des IDs Google Analytics par app
const ANALYTICS_CONFIG = {
  "/": "G-W70CD769KW", // App principal (accounting)
};

// Fonction pour vérifier si on est dans un iframe sandboxé
function isInSandboxedFrame() {
  try {
    // Vérifier si on est dans un iframe
    if (window.self !== window.top) {
      // Essayer d'accéder au parent pour voir si on est sandboxé
      window.parent.location.href;
      return false; // Si on peut accéder, on n'est pas sandboxé
    }
    return false; // Pas dans un iframe
  } catch (e) {
    // Si on ne peut pas accéder au parent, on est probablement sandboxé
    return true;
  }
}

// Fonction pour obtenir l'ID Analytics selon le path
export function getAnalyticsId(pathname) {
  for (const [path, id] of Object.entries(ANALYTICS_CONFIG)) {
    if (pathname.startsWith(path) && path !== "/") {
      return id;
    }
  }
  return ANALYTICS_CONFIG["/"];
}

// Fonction pour initialiser Google Analytics
export function initializeAnalytics(trackingId) {
  if (!trackingId || typeof window === "undefined") return;

  // Vérifier si on est dans un iframe sandboxé
  if (isInSandboxedFrame()) {
    console.log("⚠️ Analytics - In sandboxed iframe, skipping initialization");
    return;
  }

  // Vérifier si gtag existe déjà
  if (window.gtag) {
    window.gtag("config", trackingId);
    return;
  }

  // Créer le script gtag
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  document.head.appendChild(script);

  // Initialiser gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", trackingId);
}

// Fonction pour tracker les changements de page
export function trackPageView(pathname, trackingId) {
  // Ignorer si on est dans un iframe sandboxé
  if (isInSandboxedFrame()) {
    return;
  }

  if (window.gtag && trackingId) {
    window.gtag("config", trackingId, {
      page_path: pathname,
    });
  }
}
